<template lang="pug">
  v-dialog(v-model='dialog' persistent max-width='1000px')
    v-card(grid-list-md)
      v-toolbar(dark, color='primary')
        v-toolbar-title {{ $t('pageHeader.editStore') }}
      v-card-text(v-if="!isLoading")
        v-container(grid-list-lg)
          v-layout(row)
            v-flex(xs12)
              div Location Information
              v-layout(row wrap)
                v-flex(xs12 sm6)
                  v-text-field(autofocus v-model="editLocation.businessName"
                   :error-messages="businessNameErrors" label='Business Name')
                v-flex(xs12 sm6)
                  //- Address(@addressSubmit="setAddress" :initAddress="editLocation.address")

                  v-text-field(
                    autofocus
                    v-model="editLocation.address"
                    label='Address'
                  )
                  //- v-text-field(v-model="editLocation.address"
                  //- :error-messages="addressErrors" label='Address')
          v-layout(row wrap)
            v-flex(xs12)
              v-layout(row wrap)
                v-flex(xs12 sm3)
                  v-text-field(v-model="editLocation.city" :error-messages="cityErrors" label='City')
                v-flex(xs12 sm3)
                  v-select(
                    :items="states"
                    :label="$t('labels.state')"
                    item-text="stateName"
                    item-value="stateID"
                    v-model="editLocation.stateID")
                v-flex(xs12 sm3)
                  v-text-field(v-model="editLocation.zipCode" :error-messages="zipCodeErrors" label='Zip code')
                v-flex(xs12 sm3)
                  v-text-field(v-model="editLocation.businessPhone" :error-messages="businessPhoneErrors" label='Phone Number')
                v-flex(xs12 sm3)
                  v-text-field(v-model="editLocation.cellPhone" label='Cell Number')
                v-flex(xs12 sm4)
                  v-text-field(v-model="editLocation.businessEmail" label='Email Address')
                v-flex(xs12 sm5)
                  v-text-field(v-model="editLocation.webSite" label='Web Site')
              v-layout(row wrap)
                  v-flex(xs12 sm4)
                    v-select(
                      :items="comboBoxByID(13).ComboBoxDetails"
                      :label="$t('labels.whereDidYouFindUs')"
                      item-text="selector"
                      item-value="id"
                      v-model="editLocation.findUsID")
                  v-flex(xs12 sm4)
                    v-select(
                      :items="comboBoxByID(12).ComboBoxDetails"
                      :label="$t('labels.businessType')"
                      item-text="selector"
                      item-value="id"
                      v-model="editLocation.businessTypeID")
                  v-flex(xs12 sm2 v-if="!service.csp4")
                    v-text-field.right-input(type="number" v-model="editLocation.smsRate"
                    :error-messages="smsRateFeeErrors"
                    label='SMS Price')
                  v-flex(xs12 sm2 v-if="!service.csp4")
                    v-text-field.right-input(type="number" v-model="editLocation.mmsRate"
                    :error-messages="mmsRateFeeErrors" 
                    label='MMS Price')
      v-card-actions
        v-spacer
        v-btn(color='blue darken-1', flat, @click='close') Close
        v-btn(color='blue darken-1' dark @click='updateStore') Update

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import locationService from '../service.js'
import ticketService from '../service.js'
// import Address from '../../Global/components/Address'
import userService from '../../User/service.js'
const DateTimePicker = () => import('../../Global/components/DateTimePicker')
const { validationMixin } = require('vuelidate')
const {
  required,
  minLength,
  minValue,
} = require('vuelidate/lib/validators')

export default {
  props: {
    editDialog: {
      default: false,
    },
  },
  name: 'edit-store',
  data() {
    return {
      dueDateMenu: false,
      isLoading: true,
      dialog: false,
      editLocation: null,
    }
  },
  components: {
    DateTimePicker,
    // Address,
  },
  mixins: [validationMixin],
  validations: {
    editLocation: {
      businessName: {
        required,
        minLength: minLength(4),
      },
      address: {
        required,
        minLength: minLength(5),
      },
      city: {
        required,
        minLength: minLength(2),
      },
      zipCode: {
        required,
        minLength: minLength(4),
      },
      businessPhone: {
        required,
        minLength: minLength(10),
      },
      smsRate: {
        required,
      },
      mmsRate: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters('global', ['comboBox', 'comboBoxByID', 'currentUser', 'states', 'checkRightStatus']),
    ...mapGetters('location', ['location', 'service']),
    businessNameErrors() {
      const errors = []
      if (!this.$v.editLocation.businessName.$dirty) return errors
      if (!this.$v.editLocation.businessName.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.editLocation.businessName.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    addressErrors() {
      const errors = []
      if (!this.$v.editLocation.address.$dirty) return errors
      if (!this.$v.editLocation.address.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.editLocation.address.minLength) errors.push("Field must be at least 10 characters long")
      return errors
    },
    cityErrors() {
      const errors = []
      if (!this.$v.editLocation.city.$dirty) return errors
      if (!this.$v.editLocation.city.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.editLocation.city.minLength) errors.push("Field must be at least 10 characters long")
      return errors
    },
    zipCodeErrors() {
      const errors = []
      if (!this.$v.editLocation.zipCode.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.editLocation.zipCode.minLength) errors.push("Field must be at least 4 characters long")
      return errors
    },
    businessPhoneErrors() {
      const errors = []
      if (!this.$v.editLocation.businessPhone.$dirty) return errors
      if (!this.$v.editLocation.businessPhone.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.editLocation.businessPhone.minLength) errors.push("Field must be at least 10 characters long")
      return errors
    },
    stripeIDErrors() {
      const errors = []
      if (!this.$v.editLocation.stripeID.$dirty) return errors
      if (!this.$v.editLocation.stripeID.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.editLocation.stripeID.minLength) errors.push("Field must be at least 10 characters long")
      return errors
    },
    smsRateFeeErrors() {
      const errors = []
      if (!this.$v.editLocation.smsRate.$dirty) return errors
      if (!this.$v.editLocation.smsRate.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    mmsRateFeeErrors() {
      const errors = []
      if (!this.$v.editLocation.mmsRate.$dirty) return errors
      if (!this.$v.editLocation.mmsRate.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
  },
  watch: {
    editDialog(val) {
      this.dialog = val
      if(val) {
        this.editLocation = _.clone(this.location)
        // console.log('editLocation', this.editLocation)
        this.isLoading = false
      }
    }
  },
  methods: {
    ...mapActions('location', ['setLocation']),
    setAddress(val) {
      this.editLocationzipCode = val.zipCode
      this.editLocation.city = val.city
      this.editLocation.country = val.country
      this.editLocation.address = val.address
      this.editLocation.latitude = val.latitude
      this.editLocation.longitude = val.longitude
      this.editLocation.stateID = val.stateID
    },
    updateStore() {
      let editData = {
        businessName: this.editLocation.businessName,
        address: this.editLocation.address,
        city: this.editLocation.city,
        stateID: this.editLocation.stateID,
        zipCode: this.editLocation.zipCode,
        businessPhone: this.editLocation.businessPhone,
        cellPhone: this.editLocation.cellPhone,
        businessEmail: this.editLocation.businessEmail,
        webSite: this.editLocation.webSite,
        findUsID: this.editLocation.findUsID,
        businessTypeID: this.editLocation.businessTypeID,
        smsRate: this.editLocation.smsRate,
        mmsRate: this.editLocation.mmsRate,
        longitude: this.editLocation.longitude,
        latitude: this.editLocation.latitude,
      }
      console.log("editLocation is : ", editData)

      return locationService.updateStore(this.editLocation.storeID, editData)
      .then(result => {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'success',
          title: 'Update Successfully'
        })
        this.close()
        this.setLocation(this.editLocation.storeID)
      })
    },
    setDate(val) {
      console.log(val)
      this.editLocation.dueDateV2 = val
    },
    close() {
      this.$emit('close')
    },
    save() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'error',
          title: this.$t('toastMessage.text.invalidFields')
        })
      } else {
        console.log('tickets', this.Ticket)
        let contactStatus = false
        if(!this.Ticket.phoneNumber) {
          if(!this.Ticket.email) {
            contactStatus = false
          }else {
            contactStatus = true
          }
        } else {
          contactStatus = true
        }
        if (!contactStatus) {
          this.$swal('Ticket', 'Please enter contact phone number or email address', 'warning')
        }else {
          console.log('everything good')
          this.Ticket.storeID = this.editLocation.storeID
          this.Ticket.loginEmail = this.currentUser.loginEmail
          return ticketService.create(this.Ticket)
          .then(result => {
            if (result.status) {
              this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
              }).fire({
                type: 'success',
                title: 'Ticket is created'
              })
              this.$emit('created')
            }
            console.log('ticket created', result)
          }).catch(err => {
            this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            }).fire({
              type: 'error',
              title: err.data.data
            })
          })
        }
      }


      // title: $('#ticketTitle1').val(),
      // ticketTypeID: $("#type option:selected").val(),
      // reporterUserID:#{userData.userID},
      // assignedToUserID:$('#assignedTo').val(),
      // description:$('#description').val(),
      // solution:$('#solution').val(),
      // storeID:#{store.data.storeID},
      // languageID:$("#language option:selected").val(),
      // sourceID:$("#source option:selected").val(),
      // phoneNumber:$('#contactNumber').val(),
      // name:$('#callerName').val(),
      // email:$('#emailAddress').val(),
      // priorityID:$("#priority option:selected").val(),
      // statusID:$("#status option:selected").val(),
      // softwareID:$("#software option:selected").val(),
      // createdAt: new Date().toISOString(),
      // dueDate: new Date().toISOString()
    }
  }
}
</script>

<style scoped>
</style>
